export function getSkillsFromCommaSeparatedString(skillsString) {
  if (!skillsString) return [];
  return skillsString.split(',').map(skill => skill.trim());
}
